/**
 * Handle Footer Main Mobile Navigation
 * @author Jose Molina, NESN
 */

export default {

	/**
	 * Initialize collapsible functionality
	 */
	init() {
		const footerMobile = document.getElementById( 'siteFooterMenuMobile' );

		setTimeout( function () {
			if ( ! footerMobile.classList.contains( 'sticky' ) && 768 >= window.innerWidth ) {
				document.body.classList.add( 'footer-mobile-menu-is-active' );
				footerMobile.classList.add( 'sticky' );
			}
		}, 500 );
	}
};
